function publicPages() {
    const page = document.querySelector('[data-public-page]');

    if (!page) {
        return;
    }

    const introItems = Array.from(page.querySelectorAll('[data-public-intro]'));
    const revealItems = Array.from(page.querySelectorAll('[data-public-reveal]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Public content is visible by default. Motion is enabled only after the
    // browser proves it can observe and reveal every item safely.
    if (reducedMotion || !('IntersectionObserver' in window)) {
        return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            currentObserver.unobserve(entry.target);
        });
    }, {rootMargin: '0px 0px -7% 0px', threshold: 0.08});

    page.classList.add('is-motion-ready');
    window.requestAnimationFrame(() => {
        introItems.forEach((item, index) => {
            window.setTimeout(() => item.classList.add('is-visible'), index * 90);
        });
    });

    revealItems.forEach((item) => observer.observe(item));

    let revealFrame = null;
    const revealPassedItems = () => {
        revealFrame = null;
        revealItems.forEach((item) => {
            if (!item.classList.contains('is-visible') && item.getBoundingClientRect().top < window.innerHeight * 0.92) {
                item.classList.add('is-visible');
                observer.unobserve(item);
            }
        });
    };
    const scheduleRevealCheck = () => {
        if (revealFrame === null) {
            revealFrame = window.requestAnimationFrame(revealPassedItems);
        }
    };

    window.addEventListener('scroll', scheduleRevealCheck, {passive: true});
    window.addEventListener('resize', scheduleRevealCheck, {passive: true});
    revealPassedItems();

    // A delayed safety pass prevents content from remaining concealed if an
    // observer stalls after the enhancement class has been applied.
    window.setTimeout(() => {
        introItems.concat(revealItems).forEach((item) => item.classList.add('is-visible'));
    }, 1800);
}

export {publicPages};
